import { getLangCode } from "../utilities/getLangCode";

const langCode = getLangCode();

export const adalConfig = {
	endpoints: {
        getwizardPane : process.env.REACT_APP_WEBSERVICE_URI + `api/v1/aem/wizard?locale=${langCode}`,
        multiappdatasave : process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/save', // save api for muliapp support
        getmultiappdata: process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/fetch',  // fetch api for multiapp support
        deletemultiappdata: process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/deleteProject', // delete api for multi app support
        getResultPane : process.env.REACT_APP_WEBSERVICE_URI + `api/v1/aem/result?locale=${langCode}`,
        getImageURI: process.env.REACT_APP_NONPROD_URI,
        draftOfferPost:
            "https://graph.microsoft.com/rp/product-ingestion/configure?$version=2022-07-01",
        draftOfferGet:
            "https://graph.microsoft.com/rp/product-ingestion/configure/",
        getUserDetails: process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/fetchuserdetails?',
        getUserDetailsbyTenant: process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/fetchuserdetailsByTenant?',
        getOfferDetails: process.env.REACT_APP_WEBSERVICE_URI + '/api/v1/qualification/fetchofferdetails?',
        getISVSuccessEnrollmentCheck: process.env.REACT_APP_WEBSERVICE_URI + "/api/v1/qualification/ISVSuccessEnrollmentCheck", // ISV Enrollment success check API,
        mloListingApi: process.env.REACT_APP_MLO_WEBSERVICE_URI + 'api/v1/marketplace/listingoptimizer', // mlo listing post api
        getLiveOffers:process.env.REACT_APP_WEBSERVICE_URI + 'api/v1/qualification/fetchofferdetailsByMPN'
	}   
};